export const CONNECTION_ONLINE_MSG = 'Você está online novamente.';
export const CONNECTION_OFFLINE_MSG = 'Conexão perdida! Você não está conectado à Internet.';
